export { default } from './HelpCenterLinkIcon';
